"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndefiniteValueHeader = exports.DictionaryItemHeader = exports.DictionaryHeader = exports.ArrayItemHeader = exports.ArrayHeader = exports.ModelPropertyHeader = exports.ModelHeader = exports.ResponseArgumentHeader = exports.ResponseHeader = exports.RequestArgumentHeader = exports.RequestHeader = void 0;
class RequestHeader {
    constructor(actionName, argumentCount, tags) {
        this.actionName = actionName;
        this.argumentCount = argumentCount;
        this.tags = new Map();
        if (tags) {
            for (const tag of tags)
                this.tags.set(tag[0], tag[1]);
        }
    }
}
exports.RequestHeader = RequestHeader;
class RequestArgumentHeader {
    constructor(argumentName, type) {
        this.argumentName = argumentName;
        this.type = type;
    }
}
exports.RequestArgumentHeader = RequestArgumentHeader;
class ResponseHeader {
    constructor(success, type, argumentCount = 0) {
        this.success = success;
        this.type = type;
        this.argumentCount = argumentCount;
    }
}
exports.ResponseHeader = ResponseHeader;
class ResponseArgumentHeader {
    constructor(argumentName, type) {
        this.argumentName = argumentName;
        this.type = type;
    }
}
exports.ResponseArgumentHeader = ResponseArgumentHeader;
class ModelHeader {
    constructor(modelName, propertyCount) {
        this.modelName = modelName;
        this.propertyCount = propertyCount;
    }
}
exports.ModelHeader = ModelHeader;
class ModelPropertyHeader {
    constructor(propertyName, type) {
        this.propertyName = propertyName;
        this.type = type;
    }
}
exports.ModelPropertyHeader = ModelPropertyHeader;
class ArrayHeader {
    constructor(itemCount) {
        this.itemCount = itemCount;
    }
}
exports.ArrayHeader = ArrayHeader;
class ArrayItemHeader {
    constructor(type) {
        this.type = type;
    }
}
exports.ArrayItemHeader = ArrayItemHeader;
class DictionaryHeader {
    constructor(recordCount) {
        this.recordCount = recordCount;
    }
}
exports.DictionaryHeader = DictionaryHeader;
class DictionaryItemHeader {
    constructor(keyType, valueType) {
        this.keyType = keyType;
        this.valueType = valueType;
    }
}
exports.DictionaryItemHeader = DictionaryItemHeader;
class IndefiniteValueHeader {
    constructor(valueType) {
        this.valueType = valueType;
    }
}
exports.IndefiniteValueHeader = IndefiniteValueHeader;
